<template>
    <v-form v-model="formValido" ref="formInterno">
            <v-card>
                <v-card-title>
                    Emitente
                </v-card-title>
                <v-card-text>
                    <div>
                        <v-row>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.cpfOrCnpjEmitente" v-mask="'##.###.###/####-##'"
                                    clearable outlined label="CNPJ/CPF" @blur="getCnpjInfo(objNf.cpfOrCnpjEmitente, 'Emitente')"
                                    :rules="[v => !!v || 'Emitente é obrigatório']" 
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                            <v-text-field v-model="objNf.razaoSocialNomeEmitente" clearable outlined
                                label="Razão Social/Nome" :rules="[v => !!v || 'Razão Social é obrigatório']" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <!-- <v-text-field v-model="objNf.cnae" readonly clearable outlined label="CNAE da Empresa"
                                    :rules="[v => !!v || 'CNAE é obrigatório']" /> -->

                                <v-autocomplete 
                                    :rules="[v => !!v || 'CNAE é obrigatório']"
                                    v-model="objNf.cnae"
                                    :items="cnaeList"
                                    item-text="codigo"
                                    item-value="id" 
                                    label="CNAE" 
                                    dense 
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <div class="font-weight-bold">{{ item.codigo }}</div>
                                            <div>{{ item.descricao }}</div>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.inscricaoMinucipal" clearable outlined
                                    label="Inscrição Municipal" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.localEmissao" clearable outlined label="Local de Emissão" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteLogradouro" clearable outlined label="Logradouro" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteBairro" clearable outlined label="Bairro" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteCodCidade" clearable outlined label="Código da Cidade" />
                            </v-col>
                        </v-row>
                    </div>

                    <div>
                        <v-row>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete 
                                    v-model="objNf.regimeTributario"
                                    :items="regimeTributarioList" 
                                    item-text="descricao"
                                    item-value="id" 
                                    label="Regime Tributario" 
                                    dense 
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <div class="font-weight-bold">{{ item.codigo }}</div>
                                            <div>{{ item.descricao }}</div>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete 
                                    v-model="objNf.enquadramento"
                                    :items="enquadramentoList" 
                                    item-text="descricao"
                                    item-value="id" 
                                    label="Enquadramento" 
                                    dense 
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <div class="font-weight-bold">{{ item.codigo }}</div>
                                            <div>{{ item.descricao }}</div>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete 
                                    v-model="objNf.tributacaoMunicipal"
                                    :items="tributacaoList" 
                                    item-text="naturezaOperacao"
                                    item-value="id" 
                                    label="Tributação Municipal" 
                                    dense 
                                    outlined
                                    return-object
                                    @change="selectedTributacao"
                                >
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <div class="font-weight-bold">{{ item.codigo }}</div>
                                            <div>{{ item.naturezaOperacao }}</div>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-combobox 
                                    v-model="objNf.enqServico" 
                                    :items="['MEI', 'Simples Nacional', 'Lucro Presumido']"
                                    clearable outlined label="Tipo de Enquadramento" 
                                />
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>

            <v-card class="mb-5 mt-5">
                <v-card-title>
                    Tomador do Serviço
                </v-card-title>

                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete 
                                clearable outlined label="Cliente" 
                                v-model="objNf.destinatario" 
                                :items="clientes" 
                                item-value="id"
                                item-text="nomeFantasia"
                                return-object
                                @change="$emit('selectedCliente', objNf.destinatario)"
                            />
                        </v-col>

                        <v-col cols="3">
                            <v-text-field v-model="objNf.cpfOrCnpjTomador" v-mask="'##.###.###/####-##'" clearable
                                outlined label="CNPJ/CPF" @blur="getCnpjInfo(objNf.cpfOrCnpjTomador, 'Tomador')"
                                :rules="[v => !!v || 'CNPJ é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.razaoSocialNomeTomador" clearable outlined
                                label="Razão Social/Nome" :rules="[v => !!v || 'Razão Social é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.inscricaoMinucipalTomador" clearable outlined
                                label="Inscrição Municipal"
                                 />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field readonly v-model="objNf.endereco" clearable outlined label="Endereço Completo"
                                :rules="[v => !!v || 'Endereço é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.codigoCidade" clearable outlined label="Código da Cidade"
                                :rules="[v => !!v || 'Código é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorUf" clearable outlined label="UF"
                                :rules="[v => !!v || 'UF é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorNumero" clearable outlined label="Número" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorComplemento" clearable outlined label="Complemento" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorCep" clearable outlined label="CEP"
                                :rules="[v => !!v || 'CEP é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorEmail" clearable outlined label="E-mail"
                                :rules="[v => !!v || 'E-mail é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.localRecebimento" clearable outlined
                                label="Local do Recebimento" />
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>

            <v-card>
                <v-card-title>
                    Job
                </v-card-title>

                <v-card-text>
                    <v-autocomplete 
                        v-model="objNf.job" 
                        :items="projects" 
                        item-text="code" 
                        item-value="id"
                        label="JOB" 
                        dense 
                        outlined
                        @change="selectedJob"
                        return-object
                    >
                    </v-autocomplete>

                    <v-data-table
                        v-model="objNf.jobItens"
                        :headers="headers"
                        :items="dataItensJob"
                        class="elevation-1"
                        disable-sort
                        hide-default-footer
                        show-select 
                        color="primary"
                        return-object
                    >
                    </v-data-table>

                    <v-row class="mt-5">
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined 
                                label="Valor da Nota"
                                v-model="objNf.valorNf" 
                                :readonly="true"
                                :key="updtaeSum"
                            />
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined 
                                label="Base Calculo"
                                v-model="objNf.baseCalculo" 
                                :key="updtaeSum"
                            />
                        </v-col>

                        <v-col cols="12" sm="6" md="2">
                            <v-select 
                                :items="aliquoataOptions" 
                                clearable 
                                outlined
                                label="Aliquota(%)"
                                v-model="objNf.aliquota"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined
                                label="Imposto"
                                v-model="objNf.imposto"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined
                                label="Dedutivel"
                                v-model="objNf.dedutivel"
                            />
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>

        <div class="mb-5 mt-5" style="width: 100%">
            <v-card>
                <v-card-title>
                    Parcelas - {{ sumParcelas()?.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' }) }} - {{ valorNf }}
                </v-card-title>

                <div>
                <v-row dense v-for="parcela in parcelas" :key="parcela.numParcela">
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="N° Parcela" v-model="parcela.numParcela" readonly />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="Data de Vencimento" type="date" v-model="parcela.vencimento" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :rules="[
                                v => {
                                    const valor = valorNf
                                    return valor >= sumParcelas() || 'Não pode ultrapassar a parcela'
                                }
                            ]"
                            clearable outlined label="Valor da Parcela" 
                            v-money="money" 
                            v-model="parcela.vrlParcela" 
                        />
                    </v-col>

                    <!-- Botão com ícone ao final -->
                    <v-col cols="12" sm="6" md="4" >
                        <v-btn color="primary" icon @click="addParcela()">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn color="error" icon @click="removeParcela(parcela)">
                            <v-icon>mdi-minus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                </div>

            </v-card>
        </div>
            

            <v-card>
                <v-card-title>
                    Serviço Prestado
                </v-card-title>

                <v-card-title :key="componentKey">
                    <v-row dense>
                        <v-col cols="12" md="12" lg="12">
                            <v-text-field v-model="objNf.tipoServico" clearable outlined label="Tipo de Serviço" />
                        </v-col>

                        <!-- <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.codMunicipio" clearable outlined label="Código do serviço no município" />
                        </v-col> -->

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.pis" v-money="money" clearable outlined label="PIS" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.confins" v-money="money" clearable outlined label="COFINS" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.csll" v-money="money" clearable outlined label="CSLL" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.ir" v-money="money" clearable outlined label="IR" @blur="calcImpostos()" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.inss" v-money="money" clearable outlined label="INSS" @blur="calcImpostos" />
                        </v-col>

                        <!-- <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.iss" v-money="money" clearable outlined label="ISS" @blur="calcImpostos" />
                        </v-col> -->

                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.liquidos" :key="updtaeSum" v-money="money" clearable outlined label="Valor Líquido" :readonly="true" />
                        </v-col>
<!--
                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.dataEmit" type="date" clearable outlined label="Data de Emissão" :readonly="true" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.dateVenc" type="date" clearable outlined label="Data de Vencimento" />
                        </v-col> --->
                        <v-col cols="12" md="12" lg="12">
                            <v-textarea v-model="objNf.descricao" clearable outlined label="Descrição detalhada do serviço prestado" />
                        </v-col>
                    </v-row>
                </v-card-title>

            </v-card>

    </v-form>
</template>

<script>
import {VMoney} from 'v-money'
import Vue from 'vue';
export default {
    name: 'NotaFiscalServico',
    directives: { money: VMoney },
    props: ['projects', 'userInfo', 'item', 'isOpen', 'valorNf', 'clientes', 'clienteSelected', 'pacelasCads'],
    data(){
        return {
            openExpansionJobOs: false,
            salesOrders: [],
            componentKey: 0,
            totalNf: 0,
            formValido: false,
            updtaeSum: 0,
            money: {
                locale: "pt-br",
                decimal: '.',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            parcelas: this.pacelasCads.length > 0 ?  this.pacelasCads : [
                { numParcela: '01', vencimento: null, vrlParcela: 0 }
            ],
            aliquoataOptions: [
                { text: '2%', value: 2 },
                { text: '3%', value: 3 },
                { text: '4%', value: 4 },
                { text: '5%', value: 5 }
            ],
            headers: [
                { text: 'Descrição', value: 'descricao' },
                { text: 'Tipo', value: 'tipo' },
                { text: 'Quantidade', value: 'quantidade' },
                { text: 'Preço Unitario', value: 'precoUnitario' },
                { text: 'Preço Total', value: 'precoTotal' }
            ],
            dataItensJob: [],
            regimeTributarioList: [],
            enquadramentoList: [],
            tributacaoList: [],
            cnaeList: [],
            objNf: {
                baseCalculo: null,
                id: null,
                cpfOrCnpjEmitente: null,
                razaoSocialNomeEmitente: null,
                cpfOrCnpjTomador: null,
                razaoSocialNomeTomador: null,
                cnae: null,
                inscricaoMinucipal: '',
                inscricaoMinucipalTomador: '',
                endereco: null,
                codigoCidade: '',
                localEmissao: null,
                emitenteLogradouro: null,
                emitenteBairro: null,
                emitenteCodCidade: null,
                localRecebimento: null,
                tipoServico: '',
                descricao: '',
                enqServico: '',
                codMunicipio: '',
                job: null,
                os: null,
                dataEmit: null,
                dateVenc: null,
                valorNota: null,
                pis: 0,
                confins: 0,
                csll: 0,
                ir: 0,
                inss: 0,
                aliIss: 0,
                valueIss: 0,
                tributos: null,
                liquidos: 0,
                tomadorUf: null,
                tomadorNumero: null,
                tomadorCep: null,
                tomadorEmail: null,
                jobItens: [],
                regimeTributario: null,
                tributacaoMunicipal: null,
                aliquota: null,
                imposto: null,
                dedutivel: null
            }
        }
    },
    methods: {
        async getDataEntity(schemaName){
            const response = await Vue.prototype.$http.get(`/Entity/${schemaName}`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            return response.data.data.data
        },

        async selectedJob(job){
            const response = await Vue.prototype.$http.get(`/Entity/ProjectItens`, {
                params: {
                    ids: job.jobItens.map((id) => id).join(',')
                }
            })

            this.dataItensJob = response.data.data.data
        },

        selectedTributacao(tributacao){
            this.objNf.aliquota = tributacao.aliquotaIss * 100
            this.updtaeSum += 1
            this.calcImpostos()
        },

        async getEmitente(){
            const filial = localStorage.getItem('CompanySiteIdSelected')
            const response = await Vue.prototype.$http.get(`/Entity/CompanySite/${filial}`);
            this.objNf.cpfOrCnpjEmitente = response.data.data.cnpj
            this.getCnpjInfo(response.data.data?.cnpj, 'Emitente')
        },

        async getCnpjInfo(value, tipo){

            if(value?.length == 18){
                const response = await Vue.prototype.$http.post('/Action/run', 
                    { 
                        actionId: "128f5633-f624-41f8-abcf-043bc39a4bb7",
                        actionName: "Action info CNPJ",
                        params: { 
                            cnpj: value.replace(/\D/g, '')
                        } 
                    })



                if(response.data.data.data?.status == "ERROR" && tipo == 'Emitente'){
                    this.$notfy.error("CNPJ invalido.");
                    this.objNf.cpfOrCnpjEmitente = ''
                    return
                }

                if(response.data.data.data?.status == "ERROR" && tipo == 'Tomador'){
                    this.$notfy.error("CNPJ invalido.");
                    this.objNf.cpfOrCnpjTomador = ''
                    return
                }

                const info = response.data.data.data

                if(tipo == 'Emitente'){
                    this.objNf.razaoSocialNomeEmitente = info.fantasia || info.nome
                    //this.objNf.cnae = info.atividade_principal[0].code
                    this.objNf.localEmissao = info.municipio
                    this.objNf.emitenteLogradouro = info.logradouro
                    this.objNf.emitenteBairro = info.bairro
                } 
                else if(tipo == 'Tomador'){
                    this.objNf.razaoSocialNomeTomador = info.fantasia || info.nome
                    this.objNf.endereco = `Cidade: ${info.municipio} - Rua: ${info.logradouro} - Bairro: ${info.bairro}` 
                    this.objNf.localRecebimento = info.logradouro + info.numero
                    this.objNf.tomadorEmail = info.email
                    this.objNf.tomadorNumero = info.numero
                    this.objNf.tomadorUf = info.uf
                    this.objNf.tomadorCep = info.cep
                }

                this.componentKey += 1
            }
        },


        sumParcelas(){
            let sum = 0
            this.parcelas?.map((p) => {
                if(p.vrlParcela) sum += Number(String(p?.vrlParcela)?.replace(/\./g, '')?.replace(',', '.') || 0)  / 100
            })

            return sum || 0
        },

        addParcela(){
            this.parcelas.push({ 
                numParcela: String(this.parcelas.length + 1).padStart(2, '0'), 
                vencimento: null, 
                vrlParcela: 0 
            })  
        },

        async removeParcela(parcela){
            this.parcelas =  this.parcelas.filter((p) => p.numParcela != parcela.numParcela)

            if(parcela.id){
                //await Vue.prototype.$http.delete(`/Entity/FisPreDocEmiFin?id=${parcela.id}`)
            }

        },


        calcImpostos() {
            const toNumber = (v) => Number(String(v || 0).replaceAll(',', ''))

            console.log('base caluclo >>> ', this.objNf.baseCalculo)

            const base = this.objNf.baseCalculo ? String(this.objNf.baseCalculo)?.replace(/\./g, '')?.replace(',', '.') : this.valorNf * 100
            const trib = this.objNf.tributacaoMunicipal || {}

            console.log('TRIBUTAÇÃO >>> ', base, this.valorNf)

            this.objNf.pis = !isNaN(toNumber(trib.pis)) ? (toNumber(trib.pis) / 100) * base : 0
            this.objNf.confins = !isNaN(toNumber(trib.cofins)) ? (toNumber(trib.cofins) / 100) * base : 0
            this.objNf.csll = !isNaN(toNumber(trib.csll)) ? (toNumber(trib.csll) / 100) * base : 0
            this.objNf.inss = !isNaN(toNumber(trib.inss)) ? (toNumber(trib.inss) / 100) * base : 0
            this.objNf.ir = !isNaN(toNumber(trib.ir)) ? (toNumber(trib.ir) / 100) * base : 0

            const totalImpostos =
                this.objNf.pis +
                this.objNf.confins +
                this.objNf.csll +
                this.objNf.inss +
                this.objNf.ir 
                //Number(this.objNf.aliquota?.replace(/\./g, '')?.replace(',', '.')) / 100

            console.log('TOTAL IMPOSTOS >>> ', totalImpostos)
            this.objNf.liquidos = base - totalImpostos

            console.log('🧾 CÁLCULO IMPOSTOS', {
                aliquoata: this.objNf.aliquota,
                base,
                trib,
                totalImpostos,
                liquido: this.objNf.liquidos,
                pis: this.objNf.pis,
                confins: this.objNf.confins,
                csll: this.objNf.csll,
                inss: this.objNf.inss,
                ir: this.objNf.ir
            })

            this.componentKey += 1
        }




    },
    watch: {

        item: {
            async handler(value){
                // console.log('ITEM HANDLER ', value)
                this.objNf = value
            },
            deep: true,
            immediate: true
        },

        objNf: {
            handler(value){
                this.$emit('nf', value)
            },
            deep: true,
            immediate: true
        },

        ['item.jobItensList']: {
            handler(jobItensList){
                let jobItens = jobItensList?.map((item) => {
                    return {
                        ...item,
                        id: item?._id || item.id
                    }
                })

                this.objNf.jobItens = jobItens
            },
            deep: true,
            immediate: true
        },

        ['item.job']: {
            async handler(job){
                if(job){
                    const response = await Vue.prototype.$http.get(`/Entity/Project/${job}`)
                    this.selectedJob(response.data.data)
                }
            },
            deep: true,
            immediate: true
        },

        userInfo: {
            async handler(value){
                if(!value?.id){
                    const response = await Vue.prototype.$http.get(`/Entity/Cliente/${value}`)
                    this.objNf.destinatario = response.data.data
                    this.objNf.cpfOrCnpjTomador = response.data.data.cnpj
                    this.$emit('selectedCliente', this.objNf.destinatario)
                    return
                }

                this.objNf.destinatario = value
                this.objNf.cpfOrCnpjTomador = value?.cnpj
                this.getCnpjInfo(value?.cnpj, 'Tomador')
            },
            deep: true,
            immediate: true
        },

        ['objNf.jobItens'](jobItens){
            if(jobItens.length > 0){
                this.objNf.valorNf = 0 
                this.objNf.baseCalculo = 0

                jobItens?.map((item) => {
                    this.objNf.valorNf += item.precoTotal * 100
                    this.objNf.baseCalculo += item.precoTotal * 100
                })

                this.updtaeSum += 1
                this.calcImpostos()
                return
            }

            this.objNf.valorNf = 0 
        },

        async ['objNf.id']() {
            await this.getEmitente()   
        },

        parcelas: {
            handler(value){
                this.$emit('parcelas', value)
            },
            deep: true
        },

        valorNf(value){
            //this.totalNf = Number(value.replace(/\./g, '').replace(',', '.'))
            //this.calcImpostos()
        }
    },
    async created(){
        console.log('CREATED >>> ', this.objNf)
        if(!this.objNf.id){
            this.objNf.dataEmit = new Date().toISOString().split("T")[0]
            await this.getEmitente()
        }
    },

    async mounted(){
        const response = await Promise.all([
            this.getDataEntity("RegimeTributario"),
            this.getDataEntity("ServicoLC116"),
            this.getDataEntity("TributacaoMunicipal"),
            this.getDataEntity("CNAE")
        ])

        this.regimeTributarioList = response[0]
        this.enquadramentoList = response[1]
        this.tributacaoList = response[2]
        this.cnaeList = response[3]

        this.calcImpostos()
    }
}
</script>